import React, {useState} from 'react';
import {Popover, OverlayTrigger} from 'react-bootstrap';
import {Trans} from 'react-i18next';

export default function ConfirmDialog({
  placement = 'top',
  title = <Trans i18nKey="c.dialog.sure">Are you sure?</Trans>,
  confirmCallback,
  children,
}) {
  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(prev => !prev);
  };

  function handleYes() {
    confirmCallback();
    handleToggle();
  }

  function handleNo() {
    handleToggle();
  }

  return (
    <OverlayTrigger
      trigger="click"
      show={show}
      onToggle={handleToggle}
      placement={placement}
      rootClose={true}
      overlay={
        <Popover id="confirmation">
          <Popover.Header>{title}</Popover.Header>
          <Popover.Body>
            <div className="d-flex btn-group">
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={() => handleYes()}
              >
                <i className="fa fa-check-circle" />{' '}
                <Trans i18nKey="common.button.yes">Yes</Trans>
              </button>{' '}
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleNo()}
              >
                <i className="fa fa-times-circle" />{' '}
                <Trans i18nKey="common.button.no">No</Trans>
              </button>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      {children}
    </OverlayTrigger>
  );
}
